import { Navigate, Route, Routes } from 'react-router-dom';

import { AccessPage } from '../features/access/AccessPage.js';
import { LoginPage } from '../features/auth/LoginPage.js';
import { AgentEditor } from '../features/agents/AgentEditor.js';
import { DashboardPage } from '../features/dashboard/DashboardPage.js';
import { AgentsPage } from '../features/agents/AgentsPage.js';
import { InteractionsPage } from '../features/interactions/InteractionsPage.js';
import { Toasts } from '../ui/Toasts.js';
import { AppShell } from './AppShell.js';
import { RequireAuth } from './RequireAuth.js';

/**
 * Routing (S01: deep links; S03: the persistent shell).
 *
 * Real routes rather than the mock's `view` string, so an agent or an
 * interaction is linkable and the browser's back button behaves. Pages that
 * arrive in later phases resolve to a placeholder rather than a dead link.
 */
export function App(): JSX.Element {
  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route path="/access" element={<AccessPage />} />
          <Route path="/" element={<DashboardPage />} />
          <Route path="/interactions" element={<InteractionsPage />} />
          {/* The open interaction is a route too, so a call can be linked to
              directly and Back closes it. */}
          <Route path="/interactions/:interactionId" element={<InteractionsPage />} />
          <Route path="/agents" element={<AgentsPage />} />
          {/* The open agent is a route, not component state. That is what makes
              the sidebar link work as a way back out of the editor — and it
              makes an agent linkable and the browser's own Back button
              correct, which local state could not. */}
          <Route path="/agents/:agentId" element={<AgentEditor />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toasts />
    </>
  );
}
